import { render } from "./Posts.vue?vue&type=template&id=e811ad14"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"

import "./Posts.vue?vue&type=style&index=0&id=e811ad14&lang=css"

import exportComponent from "/Users/smithy/Development/Kfzapp Development/kfzapp-idea-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__